// extracted by mini-css-extract-plugin
export default {"brand":"Brands_brand__b7sf0","maxHeight":"Brands_maxHeight__xzRds"};